import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Namespace } from 'enums-lib';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IdentityStorage } from 'storage-service-lib';
import { map, catchError, of } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const identityStorage = inject(IdentityStorage);
  const serviceProviderFactory = inject(SharedServiceProviderServiceFactory);

  const identity = identityStorage.get();
  if (identity?.namespace === Namespace.bullhorn) {
    return true;
  }

  identityStorage.clear();

  const authService = serviceProviderFactory
    .getServiceProviderService(Namespace.bullhorn)
    .getAuthService();

  return authService.getToken().pipe(
    map(() => true),
    catchError(() => of(false)),
  );
};
